// Global audio controller to ensure only one track plays at a time
class AudioController {
  private currentAudio: HTMLAudioElement | null = null;
  private currentAudioId: string | null = null;

  play(audio: HTMLAudioElement, id: string): void {
    // Stop currently playing audio if it's different
    if (this.currentAudio && this.currentAudioId !== id) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
    }

    this.currentAudio = audio;
    this.currentAudioId = id;
  }

  stop(id: string): void {
    if (this.currentAudioId === id) {
      this.currentAudio = null;
      this.currentAudioId = null;
    }
  }

  getCurrentlyPlaying(): string | null {
    return this.currentAudioId;
  }
}

export const audioController = new AudioController();